import { vendorTranslations } from "./vendor-pt-br";

export const vendors_EN_US: vendorTranslations = {
	title: "Vendors",
	searchNamePlaceholder: "Search by name/login of vendor",
	header: {
		create: "Create vendor",
		batchPermissions: "Batch permissions",
	},
	list: {
		vendors: "Vendors",
		rent: "Rent",
		revenuePercentageFee: "Revenue percentage fee",
		tipPercentageFee: "Tip percentage fee",
		places: "Places",
		fiscalProfile: "Fiscal profile",
		login: "Login",
		paymentDaysOffset: "Payment days offset",
		productsSpecialFee: "Special fee",
		product: "product",
		products: "products",
		actions: {
			editVendor: "Edit vendor",
			deleteVendor: "Remove vendor",
		},
		place: "Place",
		bars: "Bars",
	},
	modal: {
		close: "Close",
		prevStep: "Previous step",
		nextStep: "Next step",
		steps: {
			dataCollection: "Vendor data",
			barSelection: "Places and bars data",
			feesCalculation: "Fees and tax profile",
			guidance: "Guide",
		},
		delete: {
			title: "Remove vendor",
			description: "Are you sure you want to permanently remove this vendor?",
			buttonConfirm: "Confirm",
		},
		mode: {
			create: "Create new vendor",
			update: "Edit Vendor",
			updateDataCollection: "Edit vendor data",
			updateLinkingBarsAndLocations: "Edit places and bars",
			updateFeesTaxProfile: "Edit rates and tax profile",
		},
		submit: {
			create: "Create vendor",
			update: "Save",
		},
		form: {
			required: "Required field",
			nonnegative: "The value must be greater than or equal to zero",
			name: {
				label: "Name",
				validation: "The name cannot be empty",
				placeholder: "Enter the vendor's name",
				nonempty: "Name cannot be empty",
			},
			login: {
				label: "Login",
				validation: "The login cannot be empty",
				placeholder: "Enter the vendor's login",
				nonempty: "Login cannot be empty",
				emailRegexValidation: "The login must not be an email",
				charactersRegexValidation:
					"The login must not contain uppercase letters and special characters",
			},
			password: {
				label: "Password",
				validation: "The password cannot be empty",
				placeholder: "Enter the vendor's password",
				required: "Password required",
				nonempty: "Password cannot be empty",
			},
			places: {
				label: "Places",
				validation: "Select at least one place",
				placeholder: "Select the places where the vendor will be active",
				selectAll: "Select all",
			},
			bars: {
				label: "Bars",
				validation: "Select at least one bar",
				placeholder: "Select the bars of the vendor",
				noBars: "No bars selected",
			},
			dailyRentalFeeValue: {
				label: "Fixed fee per event",
			},
			revenuePercentageFee: {
				label: "Percentage fee on revenue",
			},
			tipPercentageFee: {
				label: "Percentage fee on service",
			},
			paymentDaysOffset: {
				label: "Days to perform payment (D+)",
				maxValidation: "Must be between 0 and {{count}}",
			},
			anticipationFee: {
				label: "Anticipation fee",
			},
			fiscalProfileId: {
				label: "Fiscal profile",
				placeholder: "Select the fiscal profile",
			},
			isFinancialVendor: {
				label: "Financial closures",
				description: "Generate financial closures for this vendor",
			},
			paymentMethodFees: {
				credit: "Fee on credit payment",
				debit: "Fee on debit payment",
				pix: "Fee on pix payment",
			},
			productFees: {
				productFee: "Special fee per product",
				productFeePlaceholder: "Search for a product",
				percent: "Percentual",
				button: "Add another product",
			},
			fullName: {
				label: "Full name",
				validation: "The full name cannot be empty",
				nonempty: "The full name cannot be empty",
				placeholder: "Enter the vendor's full name",
				required: "Full name required",
			},
			postalCode: {
				label: "Postal code",
				required: "Postal code required",
				invalid: "Invalid postal code",
				placeholder: "Enter the vendor's postal code",
			},
			streetName: {
				label: "Street name",
				required: "Street name required",
				nonempty: "Street name cannot be empty",
				placeholder: "Enter the vendor's street name",
			},
			addressNumber: {
				label: "Number",
				required: "Number required",
				nonempty: "Number cannot be empty",
				placeholder: "Enter the vendor's street number",
			},
			city: {
				label: "City",
				required: "City required",
				nonempty: "City cannot be empty",
				placeholder: "Enter the vendor's city",
			},
			state: {
				label: "State",
				required: "State required",
				nonempty: "State cannot be empty",
				placeholder: "Enter the vendor's state",
			},
			province: {
				label: "Province",
				placeholder: "Enter the vendor's province",
				required: "Province required",
			},
			complement: {
				label: "Complement",
				placeholder: "Enter the vendor's complement",
				required: "Complement required",
			},
			phone: {
				label: "Phone",
				required: "Phone required",
				nonempty: "Phone cannot be empty",
				invalid: "Invalid phone",
				placeholder: "Enter the vendor's phone",
			},
			email: {
				label: "E-mail",
				required: "E-mail required",
				nonempty: "E-mail cannot be empty",
				invalid: "Invalid e-mail",
				placeholder: "Enter the vendor's e-mail",
			},
			documentType: {
				label: "Document type",
				placeholder: "Select the document type",
				required: "Document type is required",
			},
			documentNumber: {
				label: "Document number",
				placeholder: "Enter the document number",
				required: "Document number is required",
			},
			cpf: {
				label: "CPF",
				placeholder: "Enter the CPF of the vendor",
			},
			cnpj: {
				label: "CNPJ",
				placeholder: "Enter the CNPJ of the vendor",
			},
			international: {
				label: "International document",
				placeholder: "Enter the international document",
			},
			floorComplement: "Minimum guaranteed per event",
			featureAlert:
				"The remaining charge will only be distributed if the main bar of the cash register that made the charge is of the vendor. It is charged on the sales tax over the remaining charge of the vendor.",
		},
		guidance: {
			vendorData: {
				title: "Edit vendor data",
				description: "Name, login and password",
			},
			linkingBarsAndLocations: {
				title: "Edit places and bars",
				description: "Select the places of the vendor and their bars",
			},
			feesTaxProfile: {
				title: "Edit rates and fiscal profile",
				description:
					"Daily rates, percentage on revenue, percentage on service, payment day and fiscal profile",
			},
		},
		productModal: {
			title: "Products and special fees",
			product: "Product",
			fee: "Fee",
			closeConfirmTitle: "Discard changes in special fees",
			closeConfirmSubtitle:
				"You made changes and they will only be saved if you click on 'save changes'. Do you want to discard the changes made or go back to editing the rates?",
			closeConfirmCancelActionText: "Go back to editing",
			closeConfirmConfirmActionText: "Discard changes",
			save: "Save changes",
			deleteConfirmTitle: "Remove special fee",
			deleteConfirmSubtitle: "Do you want to remove the special fee of '{{value}}'?",
			deleteConfirmBoldSubtitle: "This action cannot be undone",
		},
	},
	modalPermissions: {
		single: {
			edit: "Edit {{vendorName}}",
			withdraw: "Block withdraw",
			anticipation: "Allow anticipation request",
			financialVendor: "Generate financial closures",
			remove: "Remove vendor",
		},
		multiple: {
			title: "{{count}} selected vendors",
			blockWithdraw: {
				title: "Block withdraw",
				subtitle: "Block withdraw of {{count}} vendors",
				description:
					"This action will block the withdraw of the vendors below in all places.",
				confirm: "Confirm block withdraw",
			},
			canAnticipate: {
				title: "Allow anticipation",
				subtitle: "Block anticipation of {{count}} vendors",
				description:
					"This action will block the anticipation of the vendors below in all places.",
				confirm: "Confirm block anticipation",
			},
			cancel: "Close",
			applySelection: "Apply selection",
		},
		thisAction: "This action will",
		vendorsBelow: "of the vendors below in all places",
		featureTitleBothAllowed: "Allow withdraw and anticipation",
		featureTitleBothBlocked: "Block withdraw and anticipation",
		featureTitleMixed: "{{withdraw}} withdraw and {{anticipation}} anticipation",
		block: "Block",
		allow: "Allow",
		vendorsCount_one: "of 01 vendor",
		vendorsCount_other: "of {{count}} vendors",
	},
};
